import { SEARCH } from "./actionTypes";

export const searchBooks = (books, query) => {
  return {
    type: SEARCH,
    payload: {
      books: books,
      query: query?.toLowerCase(),
    },
  };
};
